import {Button, Divider, notification, Space, Spin} from 'antd';
import {IComponentMeta, ComponentFC} from './components';
import {Editor, Viewer} from '@bytemd/react';
import gfm from '@bytemd/plugin-gfm';
import highlight from '@bytemd/plugin-highlight';
import {EditOutlined} from '@ant-design/icons';
import {useState} from 'react';
import apis from '../../apis/apis';
import 'bytemd/dist/index.min.css';
import './main.css';
import 'github-markdown-css';
import 'highlight.js/styles/solarized-light.css';


// plugins for bytemd
const plugins = [gfm(), highlight()];

interface IMain {
  Text: string,
}

const Main: ComponentFC = ({diary, comp, mutate, editable}) => {
  const main = JSON.parse(comp.Content) as IMain;

  const [mode, setMode] = useState<'view' | 'edit'>('view');
  const [text, setText] = useState<string>(main.Text);
  const [loading, setLoading] = useState<boolean>(false);

  const cancel = () => {
    setText(main.Text);
    setMode('view');
  };

  const commit = async () => {
    setLoading(true);
    try {
      await apis.diaries.setComponent(diary.Key, diary.Revision, Meta.Kind, Meta.Version, {
        Text: text,
      });
      // after set success
      notification.success({message: 'commit success'});
      mutate();
      // no need set mode and loading here
      // mutate make all component reload
      // this component will be destoried and crete an new one
    } catch (e: any) {
      setLoading(false);
      throw e;
    }
  };


  return <Spin spinning={loading}>
    <Space><span>&nbsp;</span></Space> {/* 占下面 float 元素原本应该在的位置 */}
    <Space style={{float: 'right'}}>
      {
        mode === 'view' ?
          <Button type='link' icon={<EditOutlined />} onClick={() => {
            setMode('edit');
          }} disabled={!editable} >Edit</Button> :
          <>
            <Button type='default' onClick={cancel}>Cancel</Button>
            <Button type='primary' disabled={main.Text === text} onClick={commit}>Commit</Button>
          </>
      }
    </Space>
    <Divider />
    {
      mode === 'view' ?
        <Viewer value={main.Text} plugins={plugins} /> :
        <Editor value={text} plugins={plugins} onChange={setText} />
    }


  </Spin>;
};


export const Meta: IComponentMeta = {
  Kind: 'main',
  Version: 0,
  Comp: Main,
  DefaultContent: () => {
    let text = localStorage.getItem('diary-main-text');
    if (text===null) {
      text =`## 琐事

.. WRITE CONTENT ...
`;
    }
    return JSON.stringify({Text: text}, null, 2);
  },
  CreateWhenCreateDiary: true,
};

